import React from 'react';

export default function DeferredIframe({ src, ...rest }) {
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    const onEnter = () => setReady(true);
    window.addEventListener('overlayEntered', onEnter);
    // If event already fired in this cycle
    if (typeof window !== 'undefined' && window.__overlayEntered) {
      setReady(true);
    }
    return () => window.removeEventListener('overlayEntered', onEnter);
  }, []);

  return (
    <iframe
      {...rest}
      src={ready ? src : undefined}
      data-src={src}
    />
  );
}


